import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { PriceWrite, PricingItem } from '@/types/pricing';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

/** A blank MSRP or MAPP is left out. */
export type PricingItemCreate = { price: PriceWrite; msrp?: PriceWrite; mapp?: PriceWrite };

/**
 * Creates the product's pricing item. A product has at most one, so a second create fails. The response is the item as
 * created, with no custom prices or promotions yet.
 */
export const createPricingItem = async (
  scope: RequestScope,
  { productId, data }: { productId: number; data: PricingItemCreate },
  options: WriteRequestOptions
): Promise<EndpointResponse<PricingItem>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<PricingItem>>(`product/${productId}/pricing_item`, data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
